import React from 'react';
import './CollapsiblePanel.css';

const EDGE_ICONS = {
  left: { collapsed: '›', expanded: '‹' },
  right: { collapsed: '‹', expanded: '›' },
  bottom: { collapsed: '▲', expanded: '▼' },
};

function CollapsiblePanel({
  title,
  collapsed,
  onToggle,
  edge = 'left',
  children,
  className = '',
}) {
  const isSide = edge === 'left' || edge === 'right';
  const icons = EDGE_ICONS[edge] || EDGE_ICONS.left;
  const icon = collapsed ? icons.collapsed : icons.expanded;

  return (
    <div
      className={[
        'collapsible-panel',
        isSide ? 'collapsible-panel--side' : 'collapsible-panel--bottom',
        collapsed ? 'collapsible-panel--collapsed' : 'collapsible-panel--expanded',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <button
        type="button"
        className="collapsible-panel-toggle"
        onClick={onToggle}
        title={collapsed ? `Expand ${title}` : `Collapse ${title}`}
        aria-expanded={!collapsed}
        aria-label={`${collapsed ? 'Expand' : 'Collapse'} ${title} panel`}
      >
        <span className="collapsible-panel-toggle-icon" aria-hidden="true">
          {icon}
        </span>
        <span className="collapsible-panel-toggle-label">{title}</span>
      </button>
      <div
        className={[
          'collapsible-panel-content',
          collapsed ? 'collapsible-panel-content--hidden' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-hidden={collapsed}
      >
        {children}
      </div>
    </div>
  );
}

export default CollapsiblePanel;
